<template>
  <div class="container">
      <div>
          <input v-model="form.userName" value placeholder="请输入账号" />
          </input>
      </div>
      <div>
          <input type="password" v-model="form.password" placeholder="请输入密码">
          </input>
      </div>

      <div>
          <input class="button"  @click="handleSubmit" type="button" value="登录平台" placeholder="">
        <!-- <Button @click="handleSubmit"  type="primary" long placeholder>登录进入实验</Button> -->
      </div>

  </div>
</template>
<script>
import Qs from "qs";
import axios from "@/libs/api.request";
import md5 from "js-md5";
export default {
  data() {
    return {
      form: {
        userName: "lipengxinyong",
        password: "123456",
      },
      sendsystem: true,
    };
  },
  methods: {
    //点击登录
    handleSubmit() {
      localStorage.removeItem("userid");
      localStorage.removeItem("authToken");
      localStorage.removeItem("account");
      localStorage.removeItem("realname");
      localStorage.removeItem("systype");
      localStorage.removeItem("sendurl");

      //localStorage.remove();
      var userName = "lipengxinyong";
      var password = "123456";
      var posturl = this.config.baseUrl.pro + "/login/apiLogin";
      password = md5(password);
      userName = userName.trim();
      let postdata = {
        User_Name: userName,
        Secretkey: password,
        rememberClient: true,
      };
      //登录
      return axios
        .request({
          url: posturl,
          method: "post",
          changeOrigin: true, //允许跨域
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          data: Qs.stringify(postdata),
        })
        .then((resp) => {
          console.log(resp);
          if (resp.status == 200) {
            var data = resp.data.result;
            if (data.success) {
              console.log(resp);
              localStorage.setItem("userid", data.data.user.id);
              localStorage.setItem("authToken", data.token);
              localStorage.setItem("account", data.data.user.user_Name);
              localStorage.setItem("realname", data.data.user.real_Name);
              localStorage.setItem("systype", data.data.sysType);
              localStorage.setItem("sendurl", data.data.url);
              this.sendsystem = false;

              this.getConfig();
              // alert(localStorage.getItem("sendurl"));
              var sendurl = "/" + localStorage.getItem("sendurl");

              window.location.href = sendurl;
            } else {
              // this.$Message.error("登录失败，用户名或密码错误");
              this.$Modal.error({
                title: "提示",
                content: "登录失败，" + data.message,
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
          return { code: -1, message: "登录失败", token: null, data: "" };
        });
    },
    getConfig() {
      var posturl = this.config.baseUrl.pro + "/Base_Config/apiGetConfigLoad";
      return axios
        .request({
          url: posturl,
          method: "POST",
          changeOrigin: true, //允许跨域
          headers: {
            "Content-Type": "application/x-www-form-urlenCoded",
            authToken: localStorage.getItem("authToken"),
            accept: "text/plain",
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            var data = resp.data.Result.Data;
            console.log(data);
            for (var i = 0; i < data.length; i++) {
              var item = data[i];
              localStorage.setItem(item.Code, item.Value);
              localStorage.removeItem("TeacherEnCode");
              localStorage.removeItem("TeacherEnCodes");
              localStorage.removeItem("StudentEnCode");
              localStorage.removeItem("StudentEnCodes");
            }
          } else {
            localStorage.clear();
            this.loginStatus();
          }
        })
        .catch((err) => {
          localStorage.clear();
          this.loginStatus();
          console.log(err);

          return { code: -1, message: "登录失败", token: null, data: "" };
        });
    },
  },
  created() {

    this.handleSubmit();
    //this.getdate();
  },
};
</script>




// WEBPACK FOOTER //
// src/view/noLogin.vue